import { render, staticRenderFns } from "./vtp-modal.vue?vue&type=template&id=5b29f63d"
import script from "./vtp-modal.vue?vue&type=script&lang=js"
export * from "./vtp-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports